<div class>
    <form
        name="form"
        (ngSubmit)="f.form.valid && proceesData(f)"
        #f="ngForm"
        novalidate
    >
        <div class="row">
            <div class="col-md-6">
                <div class="form-group padding-right-10">
                    <mat-form-field>
                        <mat-select
                            disableOptionCentering
                            placeholder="Type"
                            [(ngModel)]="userData.typeId"
                            name="type"
                            #type="ngModel"
                            required
                        >
                            <mat-option
                                *ngFor="let item of typeList"
                                [value]="item.id"
                            >
                                {{ item?.type }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-form-field>
                        <input
                            matInput
                            placeholder="Section Name"
                            [(ngModel)]="userData.section"
                            name="section"
                            #section="ngModel"
                            required
                        >
                    </mat-form-field>
                </div>
            </div>
        <div class="col-lg-12 margin-top-20 text-center">
                <button
                    mat-raised-button
                    color="primary"
                    class="mat-button-large"
                    type="submit"
                    [disabled]="!f.valid"
                    *ngIf="!userData?.id"
                >
                    Submit
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    class="mat-button-large"
                    type="submit"
                    *ngIf="userData?.id"
                >
                    Update
                </button>
            </div>
        </div>
    </form>
</div>
<br>
<div class="col-lg-12 row">
    <div class="col-lg-12 ml-2 data-sect">
        <div class="col-lg-12">
            <h3>Section List</h3>
        </div>
        <hr>
        <table
            class="table"
            [svData]="sectionList"
            #sv="svDataTable"
            [svRowsOnPage]="pageSize"
            *ngIf="sectionList && sectionList.length > 0"
        >
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Section</th>
                    <th class="text-center">Edit</th>
                    <th class="text-center">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sv.data">
                    <td>{{ item.type }}</td>
                    <td>{{ item.sections }}</td>


                    <td class="text-center">
                        <img
                            src="assets/icons/edit.png"
                            class="cursor-pointer"
                            (click)="editData(item.id)"
                        >
                    </td>
                    <td class="text-center">
                        <img
                            src="assets/icons/delete_icon.png"
                            class="cursor-pointer"
                            (click)="deleteData(item.id)"
                        >
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="sectionList?.length > pageSize">
                <tr>
                    <td
                        colspan="4"
                        class="center-paginator"
                    >
                        <sv-bootstrap-paginator></sv-bootstrap-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>
        <div *ngIf="sectionList?.length <= 0">No data found</div>
    </div>
</div>
